(function () {
  const PRODUCT_SELECTOR = ".globo_color_swatch_bundle_quantity_break";

  const ZIPPER_BELT_IMAGE =
    "https://cdn.shopify.com/s/files/1/0866/9541/2059/files/NEW_BELT.png?v=1756643363";

  function addVariantNumberSwatches() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block
        .querySelectorAll(".gcw-quantity-break__offer-variant__content")
        .forEach(function (variantContent) {
          const numberBox = variantContent.querySelector(
            ".gcw-quantity-break__offer-variant-number"
          );

          if (!numberBox) return;

          let image = numberBox.querySelector(".z2-variant-number-swatch");

          if (!image) {
            image = document.createElement("img");
            image.className = "z2-variant-number-swatch";
            numberBox.appendChild(image);
          }

          image.src = ZIPPER_BELT_IMAGE;
          image.alt = "Running Belt Zipper";
        });
    });
  }

  function updateFreeGiftTitles() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block.querySelectorAll(".free-gift--title").forEach(function (title) {
        const originalTitle = title.textContent.trim();

        if (!originalTitle) return;
        if (originalTitle.toUpperCase().startsWith("+ GRATIS")) return;

        title.textContent = "+ GRATIS " + originalTitle;
      });
    });
  }

  function addExtraLabelsToTwoBelts() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block.querySelectorAll(".gcw-quantity-break__offer").forEach(function (offer) {
        const title = offer.querySelector(".gcw-quantity-break__offer-title");
        const firstLine = offer.querySelector(
          ".gcw-quantity-break__offer-first-line"
        );

        if (!title || !firstLine) return;

        const titleText = title.textContent.trim().toUpperCase();

        if (titleText !== "2 BELTS") return;

        const labelsToAdd = ["GRATIS 300ML SOFT FLASK"];

        labelsToAdd.forEach(function (labelText) {
          if (
            firstLine.querySelector(
              '[data-z2-extra-label="' + labelText + '"]'
            )
          ) {
            return;
          }

          const label = document.createElement("span");
          label.className = "gcw-quantity-break__offer-label";
          label.dataset.z2ExtraLabel = labelText;
          label.textContent = labelText;

          firstLine.appendChild(label);
        });
      });
    });
  }

  function wrapTwoBeltsLabels() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block.querySelectorAll(".gcw-quantity-break__offer").forEach(function (offer) {
        const title = offer.querySelector(".gcw-quantity-break__offer-title");
        const firstLine = offer.querySelector(
          ".gcw-quantity-break__offer-first-line"
        );

        if (!title || !firstLine) return;

        const titleText = title.textContent.trim().toUpperCase();

        if (titleText !== "2 BELTS") return;

        if (firstLine.querySelector(".z2-offer-labels-wrap")) return;

        const labels = Array.from(
          firstLine.querySelectorAll(".gcw-quantity-break__offer-label")
        );

        if (!labels.length) return;

        const labelWrap = document.createElement("span");
        labelWrap.className = "z2-offer-labels-wrap";

        labels.forEach(function (label) {
          labelWrap.appendChild(label);
        });

        title.insertAdjacentElement("afterend", labelWrap);
      });
    });
  }

  function hideNullFreeGiftText() {
    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      block.querySelectorAll(".free-gift--text").forEach(function (textEl) {
        const text = textEl.textContent.trim().toLowerCase();

        if (text === "null") {
          textEl.style.display = "none";
        }
      });
    });
  }

  function updateHardcodedBundlePricing() {
    const SINGLE_BELT_PRICE = "29,95";
    const DEAL_PRICE_PER_BELT = "22,47";

    document.querySelectorAll(PRODUCT_SELECTOR).forEach(function (block) {
      const singleOffer = block.querySelector(
        '.gcw-quantity-break__offer[data-offer-index="0"]'
      );

      const dealOffer = block.querySelector(
        '.gcw-quantity-break__offer[data-offer-index="1"]'
      );

      if (singleOffer) {
        const price = singleOffer.querySelector(
          ".gcw-quantity-break__offer-price"
        );

        const comparePrice = singleOffer.querySelector(
          ".gcw-quantity-break__offer-compare-price"
        );

        setTextIfChanged(price, SINGLE_BELT_PRICE);

        if (comparePrice) {
          setTextIfChanged(comparePrice, "");
          comparePrice.style.display = "none";
        }
      }

      if (dealOffer) {
        const price = dealOffer.querySelector(
          ".gcw-quantity-break__offer-price"
        );

        const comparePrice = dealOffer.querySelector(
          ".gcw-quantity-break__offer-compare-price"
        );

        setTextIfChanged(price, DEAL_PRICE_PER_BELT);

        if (comparePrice) {
          setTextIfChanged(comparePrice, SINGLE_BELT_PRICE);
          comparePrice.style.display = "";
        }
      }
    });
  }

  function setTextIfChanged(element, value) {
    if (!element) return;

    if (element.textContent.trim() !== value) {
      element.textContent = value;
    }
  }

  function initBeltZipperBundle() {
    addVariantNumberSwatches();
    updateFreeGiftTitles();
    hideNullFreeGiftText();

    addExtraLabelsToTwoBelts();
    wrapTwoBeltsLabels();
    updateHardcodedBundlePricing();
  }

  initBeltZipperBundle();

  const observer = new MutationObserver(initBeltZipperBundle);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {
  function findSizeGuideToggle() {
    const nodes = Array.from(
      document.querySelectorAll('[class*="_ss_size_guide_2"]')
    );

    for (const el of nodes) {
      if (
        typeof el.className === "string" &&
        el.className.includes("size-toggle-")
      ) {
        return el;
      }
    }

    return null;
  }

  document.addEventListener("click", function (e) {
    const openBtn = e.target.closest("[data-z2-open-size-guide]");

    if (!openBtn) return;

    e.preventDefault();

    const toggle = findSizeGuideToggle();

    if (toggle) {
      toggle.click();
    }
  });
})();